import { ButtonWithStates } from '@comicrelief/component-library';

const defaultColor = 'grey';

const defaultStyle = { width: '100%', margin: '0px auto 0.2em' };

function ButtonLoader({ color = defaultColor, style = {} }: { color?: string, style?: object }) {
  return (
    <ButtonWithStates
      type="button"
      disabled
      loading
      color={color}
      style={{ ...defaultStyle, ...style }}
    />
  );
}

export default ButtonLoader;
